import { Button, Col, Row, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { AdminMenuLayout } from "../../../shared/components";
import { WrapperStores } from "./styled";
import { TableStores } from "./TableStores";
import { ModalStores } from "./ModalStores";
import React from "react";

const { Title } = Typography;

export const Stores = () => {
  const [openCreate, setOpenCreate] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [storeId, setStoreId] = React.useState<number>();
  const [tableTick, setTableTick] = React.useState(0);

  return (
    <AdminMenuLayout pageDescription="Sedes" title="Sedes">
      <WrapperStores>
        <Row gutter={[8, 8]} style={{ padding: "10px", width: "100%" }}>
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Title level={3} style={{ margin: 0 }}>
              Sedes
            </Title>
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={() => setOpenCreate(true)}
            >
              Nueva sede
            </Button>
          </Col>
        </Row>
        <TableStores
          key={tableTick}
          setOpenModalEdit={setOpenEdit}
          setStoreId={setStoreId}
        />
        <ModalStores
          openModalCreate={openCreate}
          setOpenModalCreate={setOpenCreate}
          openModalEdit={openEdit}
          setOpenModalEdit={setOpenEdit}
          storeId={storeId}
          onSuccess={() => setTableTick((t) => t + 1)}
        />
      </WrapperStores>
    </AdminMenuLayout>
  );
};
